import { memo, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import "../Mapa/MapaMeso.css";

const formatarData = (dataString) => {
	if (!dataString) return "Sem Previsão";
	const data = new Date(dataString);
	if (isNaN(data.getTime())) return "Data Inválida";
	const dia = data.getDate().toString().padStart(2, "0");
	const mes = (data.getMonth() + 1).toString().padStart(2, "0");
	const ano = data.getFullYear();
	return `${dia}/${mes}/${ano}`;
};

interface RastreioCardProps {
	veiculoSelecionado: any;
	onClose: () => void;
	mesoRotaNome: string;
	navegarEdicaoEmbarque: (veiculo: any) => void;
}

function RastreioCard({
	veiculoSelecionado,
	onClose,
	mesoRotaNome,
	navegarEdicaoEmbarque,
}: RastreioCardProps) {
	const [rotaSelecionada, setRotaSelecionada] = useState(null);
	const toggleRota = (idRota) => {
		setRotaSelecionada(rotaSelecionada === idRota ? null : idRota);
	};

	return (
		<div className="mapa-meso-card">
			<div className="card-header-veiculos">
				<h2>{mesoRotaNome}</h2>
				<ClearIcon className="close-button" onClick={onClose} />
			</div>
			<div className="card-header-veiculos">
				<h4>Clique na rota para ver os embarques!</h4>
			</div>
			<div
				style={{
					overflow: "auto",
					gap: "12px",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{veiculoSelecionado?.agrupadoPorRota?.map((meso, index) => (
					<div key={index} className="veiculo-detalhes">
						<p
							style={{ cursor: "pointer", fontWeight: "bold" }}
							onClick={() => toggleRota(meso.idRota)}
						>
							{meso.nomeRota} C={meso.numeroCargasAcertadas} F=
							{meso.numeroCargasNaoAcertadas}
						</p>

						{rotaSelecionada === meso.idRota && (
							<div className="embarques-list">
								<div className="card-header-veiculos">
									<h4>
										Clique no embarque para ser direcionado para a Viagem!
									</h4>
								</div>
								{meso.embarques.map((veiculo, i) => (
									<div
										key={i}
										className="veiculo-detalhes"
										onClick={() => navegarEdicaoEmbarque(veiculo)}
										style={{ paddingLeft: "20px", cursor: "pointer" }}
									>
										<p>
											<strong>CTE:</strong>{" "}
											{veiculo.cte ? veiculo.cte : "Sem CTE"}
										</p>
										<p>
											<strong>Load:</strong>{" "}
											{veiculo.load ? veiculo.load : "Sem Load"}
										</p>
										<p>
											<strong>Previsão Embarque:</strong>{" "}
											{formatarData(veiculo.previsaoEmbarque)}
										</p>
										<p>
											<strong>Cliente:</strong>{" "}
											{veiculo.cliente ? veiculo.cliente : "Sem Cliente"}
										</p>
										<p>
											<strong>Frete Fiscal:</strong>{" "}
											{veiculo.freteFiscal
												? veiculo.freteFiscal
												: "Sem Frete Fiscal"}
										</p>
									</div>
								))}
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
}

export default memo(RastreioCard);
